var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 203,
    viewBox: "0 0 229 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2706:4199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.5 130C61.2045 130 18 173.428 18 227H211C211 173.428 167.795 130 114.5 130Z",
    fill: "url(#paint0_linear_2706:4199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.534 46.7828C119.435 46.532 127.826 44.8925 133.506 39.27C139.185 33.6476 140.958 28.534 141.719 26.8139",
    stroke: "#E6E8EC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.859 30.5802C109.761 30.3294 118.152 28.6898 123.831 23.0674C129.51 17.445 131.283 12.3314 132.044 10.6113",
    stroke: "#E6E8EC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.644 64.6272C95.5541 67.1187 88.0179 65.4183 85.011 64.2566C88.4194 62.226 90.7091 60.5061 92.4497 56.7568C93.6208 54.2342 96.4895 49.353 100.031 49.1089C102.864 48.9137 105.543 50.5701 106.529 51.4227L108.73 48.066L110.484 48.6128C109.172 50.3534 105.987 54.3341 103.748 56.3313C101.508 58.3285 96.6743 61.2177 94.5373 62.4126C95.8472 62.0187 99.0018 60.9355 101.141 59.7541C103.28 58.5727 106.938 55.4644 108.499 54.058C108.799 54.5365 109.409 55.7084 109.449 56.568C109.499 57.6424 109.256 61.5129 101.644 64.6272Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7923 88.2237C62.8161 84.4272 65.6832 80.7295 69.6033 80.7295L137.402 80.7295C140.14 80.7295 142.531 82.5833 143.213 85.2352L156.911 138.506C157.887 142.302 155.02 146 151.1 146H83.3014C80.5631 146 78.1723 144.146 77.4904 141.494L63.7923 88.2237Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0669 84.5787C61.026 80.7619 63.8993 77 67.8555 77H96.4442C99.15 77 101.521 78.8109 102.233 81.4213L115.744 130.962C116.785 134.779 113.912 138.541 109.955 138.541H81.3666C78.6609 138.541 76.2899 136.73 75.578 134.119L62.0669 84.5787Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0991 89.2145C88.6872 86.4422 91.1347 84.4595 93.9685 84.4595H161.891C165.706 84.4595 168.552 87.9727 167.76 91.7045L157.252 141.245C156.663 144.017 154.216 146 151.382 146H83.4599C79.6452 146 76.799 142.487 77.5905 138.755L88.0991 89.2145Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.191 109C129.512 109 131 111.012 131 113.721C131 115.823 129.241 118.137 125.775 120.738C125.547 120.909 125.277 121 125 121C124.723 121 124.453 120.909 124.225 120.738C120.759 118.137 119 115.823 119 113.721C119 111.012 120.488 109 122.809 109C123.648 109 124.216 109.317 125 110.035C125.784 109.317 126.352 109 127.191 109Z",
    fill: "#FA6400",
    fillOpacity: 0.476699
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2706:4199",
    x1: 114.5,
    y1: 130,
    x2: 114.5,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477843,
    stopColor: "#E5EFF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706:4199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 203,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLike);
export default __webpack_public_path__ + "static/media/no-like.df091363.svg";
export { ForwardRef as ReactComponent };